var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._g(_vm._b({attrs:{"disabled":_vm.disabled,"loading":_vm.loading}},'v-btn',_vm.$attrs,false),_vm.$listeners),[(_vm.$vuetify.breakpoint.smAndUp && _vm.icon)?_c('v-icon',{attrs:{"left":""}},[_vm._v(_vm._s(_vm.icon))]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }